import {useAbout} from "../../store/about";
import NumbersCard from "./NumbersCard";

const Skills = () => {
    const numbers = useAbout((store) => store.numbers)
    return(
        <>
            <div className="about__card flex col mb-32">
                <h2 className="h2 text-center mt-52 mb-32">
                    Skills
                </h2>
                <div className="about__grid-small flex">
                    {numbers.map((item, i) => <NumbersCard key={i} {...item}/>)}
                </div>
            </div>
        </>
    )
}
export default Skills